import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getInboundHistoryById,
  getIncomingHistoryById,
  getOutboundHistoryById,
  getProductHistoryById,
} from "../../../store/actions/inventory.action";
import { getCarrierConnectHistory } from "../../../store/actions/carrierConnect.action";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LoaderSpinner from "../../common/Loader";
import Table from "react-bootstrap/Table";
import BatchPagination from "../../batch/BatchPagination";
import { numOfPage } from "../../../constant";
import moment from "moment";
import { renderTableRow } from "../../../config/utils";

const ProductHistory = (props) => {
  const { id } = useParams();
  const location = useLocation();
  const historyType = location?.state?.type;
  const productType = location?.state?.productType;
  const date = location?.state?.date;
  const landingSearch = location?.state?.landingSearch;
  const dispatch = useDispatch();

  const { productHistory, productHistoryStatus, incomingProductHistory, incomingIroductHistoryStatus } = useSelector(
    (state) => state.InventoryManagement
  );
  const { inboundHistory, inboundHistoryStatus } = useSelector(
    (state) => state.InventoryManagement
  );
  const { outboundHistory, outboundHistoryStatus } = useSelector(
    (state) => state.InventoryOutboundManagement
  );
  const { carrierConnectHistory, carrierConnectHistoryStatus } = useSelector(
    (state) => state.carrierConnect
  );
  const userDetails = useSelector((state) => state.auth.user);
  const [loader, setLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [numberOfPage, setNumberOfPage] = useState(30);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [sortingColumn, setSortingColumn] = useState("");
  const [sortOrder, setSortOrder] = useState("DESCENDING");
  const [filterData, setfilterData] = useState();
  const [listingData, setListingData] = useState([]);
  const [batchData, setBatchData] = useState([]);
  const navigate = useNavigate();

  const handleBack = () => {
    if (historyType === "product") {
      if (location?.state?.isReturn) {
        navigate("/incoming-product-listing");
        return
      }
      navigate("/inventory");
    } else if (historyType === "inbound") {
      navigate("/inbound");
    } else if (historyType === "outbound") {
      navigate("/outbound");
    } else if (historyType === "carrierConnect") {
      navigate("/carrier-connect");
    } else if (historyType === "incoming" && productType === "allProducts") {
      navigate("/incoming-product-listing")
    } else if (historyType === "incoming" && productType === "Product") {
      navigate(`/incoming-products/fd-${date}-3pl`, {
        state: { date: date, searchTxt: landingSearch },
      });
    }
  };

  useEffect(() => {
    let history = "";
    if (historyType === "product") {
      history = productHistory;
    } else if (historyType === "inbound") {
      history = inboundHistory;
    } else if (historyType === "outbound") {
      history = outboundHistory;
    } else if (historyType === "incoming") {
      history = incomingProductHistory;
    } else if (historyType === "carrierConnect") {
      history = carrierConnectHistory;
    }

    if (history?.TotalRecords > 0 || history?.totalRecords > 0) {
      const totalRecords = history?.TotalRecords || history?.totalRecords || 0;
      setTotalPages(Math.ceil(totalRecords / numberOfPage));
      setTotalRecords(totalRecords);
    }
  }, [productHistory, inboundHistory, outboundHistory, incomingProductHistory, carrierConnectHistory]);

  useEffect(() => {
    if (
      productHistoryStatus === "PENDING" ||
      inboundHistoryStatus === "PENDING" ||
      outboundHistoryStatus === "PENDING" ||
      incomingIroductHistoryStatus === "PENDING" ||
      carrierConnectHistoryStatus === "pending"
    ) {
      setLoader(true);
    } else {
      setLoader(false);
    }
  }, [productHistoryStatus, inboundHistoryStatus, outboundHistoryStatus, incomingIroductHistoryStatus, carrierConnectHistoryStatus]);

  const fetchInventoryHistory = () => {
    let data = {
      pageIndex: currentPage,
      pageSize: numberOfPage,
      sortColumn: sortingColumn,
      sortOrder: sortOrder,
      searchKeyword: "",
      id: Number(id),
    };
    if (historyType === "product") {
      dispatch(getProductHistoryById(data));
    } else if (historyType === "inbound") {
      dispatch(getInboundHistoryById(data));
    } else if (historyType === "outbound") {
      dispatch(getOutboundHistoryById(data));
    } else if (historyType === 'incoming') {
      dispatch(getIncomingHistoryById(data))
    } else if (historyType === 'carrierConnect') {
      dispatch(getCarrierConnectHistory(data))
    }
  };

  const handleSortingClass = (columnName, isArrow = false) => {
    if (isArrow) {
      return sortingColumn === columnName && sortOrder === "ASCENDING"
        ? "fa fa-arrow-up"
        : "fa fa-arrow-down";
    }
    return sortingColumn === columnName ? "active sortBtn" : "sortColumn sortBtn";
  };

  const handleSortingColumn = (event, sortColumn) => {
    event.preventDefault();
    let newSortOrder = "DESCENDING";
    setSortingColumn(sortColumn);
    if (sortColumn === sortingColumn) {
      setSortOrder(sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING");
      newSortOrder = sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
    } else {
      setSortOrder("DESCENDING");
    }
    setfilterData({
      ...filterData,
      sortColumn: sortColumn,
      sortOrder: newSortOrder,
    });
  };

  useEffect(() => {
    fetchInventoryHistory();
  }, [filterData, sortOrder, currentPage, numberOfPage]);

  // Helper function to replace "null" string values with empty string for better UI display
  const sanitizeNullValue = (value) => {
    if (value === "null" || value === null || value === undefined) {
      return "";
    }
    return value;
  };

  const handlecarrierConnectUpdate = (item) => {
    // Show carrier connect specific information
    const carrierInfo = item.carrierName ? ` for ${item.carrierName}` : '';
    const carrierConnectInfo = item.carrierConnectNumber ? ` (${item.carrierConnectNumber})` : '';
    
    // Sanitize null values for carrier connect history display
    const oldValue = sanitizeNullValue(item.oldValue);
    const newValue = sanitizeNullValue(item.newValue);
    
    return (
      <>
        <b>{item.columnName}</b>{" "}
        {`${item.action} from "${oldValue}" to "${newValue}"`}
        {carrierInfo}{carrierConnectInfo}
      </>
    );
  };

  const handleproductUpdate = (item) => {
    if (item.warehouse) {
      return (
        <>
          <b>{`${item.columnName}`}</b>{" "}
          {`${item.action} from ${item.oldValue} to ${item.newValue} for Warehouse ${item.warehouse} [${item.area} - ${item.row} - ${item.bay} - ${item.level} - ${item.position}]`} {linkInboudId(item)}
        </>
      );
    } else {
      return (
        <>
          <b>{item.columnName}</b>{" "}
          {`${item.action} from ${item.oldValue} to ${item.newValue}`} {linkInboudId(item)}
        </>
      );
    }
  };

  const handleinboundUpdate = (item) => {
    if (item.consignmentName) {
      return (
        <>
          <b>{`${item.columnName}`}</b>{" "}
          {`${item.action} from ${item.oldValue} to ${item.newValue} for `} {linkInboudId(item)}
          <b>{`${item.consignmentType}`}</b>
          {` ${item.consignmentName}`} {linkInboudId(item)}
        </>
      );
    } else {
      return (
        <>
          <b>{`${item.columnName}`}</b>{" "}
          {`${item.action} from ${item.oldValue} to ${item.newValue}`} {linkInboudId(item)}
        </>
      );
    }
  };

  useEffect(() => {
    if (historyType === "product") {
      setListingData(productHistory?.objProductHistoryEntity);
      setBatchData(productHistory?.objProductHistoryEntity);
    } else if (historyType === "inbound") {
      setListingData(inboundHistory?.Consignments);
      setBatchData(inboundHistory?.Consignments);
    } else if (historyType === "outbound") {
      setListingData(outboundHistory?.Outbounds);
      setBatchData(outboundHistory?.Outbounds);
    } else if (historyType === "incoming") {
      setListingData(incomingProductHistory?.objProductHistoryEntity);
      setBatchData(incomingProductHistory?.objProductHistoryEntity);
    } else if (historyType === "carrierConnect") {
      setListingData(carrierConnectHistory?.carrierConnects);
      setBatchData(carrierConnectHistory?.carrierConnects);
    }
  }, [inboundHistory, productHistory, outboundHistory, incomingProductHistory, carrierConnectHistory]);

  const handleCreatedAction = (item, isInboundOrOutbound, isCarrierConnect, newValue, carrierInfo, carrierConnectInfo) => {
    if (isInboundOrOutbound) {
      return (
        <>
          <b>{item.consignmentType} {item.columnName}</b>{" "}
          {item.newValue} {item.action} {linkInboudId(item)}
        </>
      );
    } else if (isCarrierConnect) {
      return (
        <>
          <b>{item.columnName}</b> {newValue} {item.action}
          {carrierInfo}{carrierConnectInfo}
        </>
      );
    } else {
      return (
        <>
          <b>{item.columnName}</b> {item.newValue} {item.action} {linkInboudId(item)}
        </>
      );
    }
  };

  const handleDeletedAction = (item, isInboundOrOutbound, isCarrierConnect, oldValue, carrierInfo, carrierConnectInfo) => {
    if (isInboundOrOutbound) {
      return (
        <>
          <b>{item.consignmentType} {item.columnName}</b>{" "}
          {item.oldValue} {item.action}
        </>
      );
    } else if (isCarrierConnect) {
      return (
        <>
          <b>{item.columnName}</b> {oldValue} {item.action}
          {carrierInfo}{carrierConnectInfo}
        </>
      );
    } else {
      return (
        <>
          <b>{item.columnName}</b> {item.oldValue} {item.action}
        </>
      );
    }
  };

  const handleAddedAction = (item, isInboundOrOutbound, isCarrierConnect, newValue, carrierInfo, carrierConnectInfo) => {
    if (isInboundOrOutbound) {
      return (
        <>
          <b>{item.consignmentType} {item.columnName}</b>{" "}
          {item.newValue} {item.action}
        </>
      );
    } else if (isCarrierConnect) {
      return (
        <>
          <b>{item.columnName}</b> {newValue} {item.action}
          {carrierInfo}{carrierConnectInfo}
        </>
      );
    } else {
      return (
        <>
          <b>{item.columnName}</b> {item.newValue} {item.action} {linkInboudId(item)}
        </>
      );
    }
  };

  const handlePrimaryAction = (item, isCarrierConnect, newValue) => {
    if (isCarrierConnect) {
      return (
        <>
          <b>{item.columnName} </b> {newValue} marked {item.action}
        </>
      );
    } else {
      return (
        <>
          <b>{item.columnName} </b> {item.newValue} marked {item.action} {linkInboudId(item)}
        </>
      );
    }
  };

  const handleHistoryView = (item) => {
    const isInboundOrOutbound = historyType === "inbound" || historyType === "outbound";
    const isCarrierConnect = historyType === "carrierConnect";
    const carrierInfo = item.carrierName ? ` for ${item.carrierName}` : '';
    const carrierConnectInfo = item.carrierConnectNumber ? ` (${item.carrierConnectNumber})` : '';

    // Sanitize null values for carrier connect history
    const oldValue = isCarrierConnect ? sanitizeNullValue(item.oldValue) : item.oldValue;
    const newValue = isCarrierConnect ? sanitizeNullValue(item.newValue) : item.newValue;

    switch (item.action) {
      case "Created":
        return handleCreatedAction(item, isInboundOrOutbound, isCarrierConnect, newValue, carrierInfo, carrierConnectInfo);
      case "Deleted":
        return handleDeletedAction(item, isInboundOrOutbound, isCarrierConnect, oldValue, carrierInfo, carrierConnectInfo);
      case "Added":
        return handleAddedAction(item, isInboundOrOutbound, isCarrierConnect, newValue, carrierInfo, carrierConnectInfo);
      case "Updated":
        if (isInboundOrOutbound) {
          return handleinboundUpdate(item);
        } else if (isCarrierConnect) {
          return handlecarrierConnectUpdate(item);
        } else {
          return handleproductUpdate(item);
        }
      case "Primary":
        return handlePrimaryAction(item, isCarrierConnect, newValue);
      default:
        return null;
    }
  };

  const navigateToInbound = (item) => {
    navigate(`/${item.outboundId ? 'outbound' : 'inbound'}/${item.outboundId || item.consignmentId}`, {
      state: {
        data: item,
        isEdit: false,
        backUrl: `/${historyType === 'product' ? 'inventory' : 'outbound'}/history-${Number(id)}`,
        id: id,
        historyType: historyType,
      }
    });
  }

  const linkInboudId = (item) => {
    if (item?.inventoryType) {
      return (
        <div className="sortBtn">
          {item.inventoryType.split('-')[0]} 
          <button className='link v' onClick={() => navigateToInbound(item)}>
            {item.inventoryType.split('-')[1]}
          </button>
        </div>
      );
    }
  }

  const handleHistoryTitle = (historyType) => {
    if (historyType === "product") {
      return "Product History"
    } else if (historyType === "inbound") {
      return "Inbound History"
    } else if (historyType === "incoming") {
      return "Incoming History"
    } else if (historyType === "carrierConnect") {
      return "Carrier Connect History"
    } else {
      return "Outbound History"
    }
  }

  // Helper function to determine what to display in Modified By column for carrier connect history
  const getModifiedByDisplay = (item) => {
    // Only apply role filtering for carrier connect history and if current user is Seller or Admin
    if (historyType === "carrierConnect") {
      const currentUserRole = userDetails?.Value?.roleName;
      const isSellerOrAdmin = currentUserRole === 'Seller' || currentUserRole === 'Admin';
      
      if (isSellerOrAdmin) {
        // For Seller and Admin roles, show the role name instead of username/email
        return item.userRole;
      }
    }
    
    // For all other cases, show the original format (username with role in parentheses if available)
    return item.userName + (item.userRole ? ' (' + item.userRole + ')' : '');
  }

  return (
    <main>
      <div className="main__container">
        <div className="main__tile_heading cus-btn-include-sec">
          History
          <div className="top_right_button_container">
            <div className="top_right_button_container">
              <button
                className="btn cus-primary-transparent-btn"
                onClick={handleBack}
              >
                Back
              </button>
            </div>
          </div>
        </div>

        {loader && <LoaderSpinner />}
        <div className="container-fluid">
          <div className="cus-page-content-sec">
            <div className="cus-tab-heading-sec">
              <div className="tabs">
                <button className="cus-tab-btn active">
                  {handleHistoryTitle(historyType)}
                </button>
                <>
                  <div className="main_content_table_history">
                    <div className="tableFixHead incomingTbl">
                      <Table
                        className={`table table-height cus-left-right-col-layout table ${loader ? "disableTble" : ""
                          }`}
                      >
                        <thead className="tbl-btch">
                          <tr className="table-rw-batch">
                            <th width={"25%"}>
                              <button
                                className={handleSortingClass("date")}
                                onClick={(e) => handleSortingColumn(e, "date")}
                                id="date"
                              >
                                Date {" "}
                                <i
                                  className={handleSortingClass("date", true)}
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </th>
                            <th width={"50%"}>Description</th>
                            <th width={"25%"}>
                              <button
                                className={handleSortingClass("modifiedBy")}
                                onClick={(e) =>
                                  handleSortingColumn(e, "modifiedBy")
                                }
                                id="modifiedBy"
                              >
                                Modified By {" "}
                                <i
                                  className={handleSortingClass(
                                    "modifiedBy",
                                    true
                                  )}
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </th>
                          </tr>
                        </thead>
                        <tbody className="tbl-bt-body">
                          {listingData?.length > 0 &&
                            listingData.map((item) => (
                              <tr key={item.id}>
                                <td style={{maxWidth: "100px"}}>
                                  {moment(item.modifiedDate || item.createdDate || item.date).format(
                                    "MM-DD-YYYY | h:mm:ss A"
                                  )}
                                </td>
                                <td className="breakWord">{handleHistoryView(item)}</td>
                                <td width={"25%"}>
                                  {getModifiedByDisplay(item)}
                                </td>
                              </tr>
                            ))}
                          {listingData && listingData.length === 0 && (
                            <>{renderTableRow(3, 'No Record Found')}</>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                  {batchData && batchData?.length > 0 && (
                    <BatchPagination
                      gridData={batchData}
                      totalVisualRecords={batchData?.length}
                      numberOfPage={numberOfPage}
                      numOfPage={numOfPage}
                      currentPage={currentPage}
                      totalPages={totalPages}
                      totalRecords={totalRecords}
                      setCurrentPage={setCurrentPage}
                      setNumberOfPage={setNumberOfPage}
                    />
                  )}
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ProductHistory;
